import NotificationService from "src/services/NotificationService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	title:"",
	content:"",
	img:"",
	show:true,
	is_run:true,
  deleteImg:""
};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.notification,
@property  {array}  modules.notifications
**/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator("notification", NotificationService, module, types ,params);
